import { useCallback } from 'react'

import TransmissionService from 'modules/transmission/service'
import { useTransmissionContext } from '../context'

const useFetchOnFireLanguages = () => {
  const { setOnFireLanguages, transmissionData: { code }, isOnFire } = useTransmissionContext()

  const fetchLanguages = useCallback(async () => {
    if (!(code && isOnFire)) {
      return
    }

    try {
      const response = await TransmissionService.getOnFireLanguages(code)

      setOnFireLanguages(response)
    } catch {
      const alreadyReloaded = sessionStorage.alreadyReloaded

      if (!alreadyReloaded) {
        sessionStorage.alreadyReloaded = true
        location.reload()
      }
      setOnFireLanguages([])
    }
  }, [code, isOnFire, setOnFireLanguages])

  return fetchLanguages
}

export default useFetchOnFireLanguages
